/**
Author - Vikrant Singh
Git - git@github.com:vikrantSingh97
**/

import PartnerEmptyAgreement from "./PartnerEmptyAgreement";

export default PartnerEmptyAgreement;
